"use client";

import { useState } from "react";
import { toast } from "sonner";

interface Props {
  value: string;
  /** Крупная версия для шапки карточки товара: больше шрифт, ярче рамка. */
  prominent?: boolean;
}

/**
 * Артикул-чип с копированием в буфер обмена. Используется в шапке карточки товара —
 * закупщик копирует код для письма поставщику или CRM-системы одним кликом.
 */
export function CopyArticleButton({ value, prominent = false }: Props) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success("Артикул скопирован", { description: value });
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Не удалось скопировать");
    }
  };

  const base =
    "group inline-flex items-center rounded-[8px] border font-mono font-medium text-text transition-colors";
  const variant = prominent
    ? "gap-2 border-brand-500 bg-brand-50 px-3 py-1.5 text-base hover:bg-brand-100"
    : "gap-1.5 border-border bg-bg-muted px-2.5 py-1 text-[13px] hover:border-brand-500 hover:bg-white";
  const iconSize = prominent ? "h-5 w-5" : "h-4 w-4";

  return (
    <button
      type="button"
      onClick={onCopy}
      aria-label={`Скопировать артикул ${value}`}
      className={`${base} ${variant}`}
    >
      <span className={prominent ? "text-brand-600" : "text-text-muted"}>арт.</span>
      <span className={prominent ? "font-bold text-text" : ""}>{value}</span>
      {copied ? (
        <svg
          aria-hidden
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          className={`${iconSize} text-success-600`}
        >
          <path d="m5 12 5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg
          aria-hidden
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className={`${iconSize} ${prominent ? "text-brand-500" : "text-text-subtle group-hover:text-brand-500"}`}
        >
          <rect x="9" y="9" width="13" height="13" rx="2" />
          <path d="M5 15V5a2 2 0 0 1 2-2h10" />
        </svg>
      )}
    </button>
  );
}
